import { render, staticRenderFns } from "./PremiumAnalysis1.vue?vue&type=template&id=ce117322&"
import script from "./PremiumAnalysis1.vue?vue&type=script&lang=js&"
export * from "./PremiumAnalysis1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports